<!-- 设备故障 -->
<template>
    <div class='container containerBox'>
        <!-- 头部筛选区 -->
        <div class="handle-box">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="时间范围">
                    <el-date-picker
                        v-model="form.time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="choseTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <l-table
            :list="list"
            :total="total" 
            :otherHeight="255" 
            :options="options"
            :pagination="pagination"
            :columns="columns" 
            :operates="operates"
            @handleSizeChange="handleSizeChange"
            @handleIndexChange="handleIndexChange">
        </l-table>

    </div>
</template>

<script>
import Service from '@/api/Service'
import lTable from '@/components/lTable/lTable'
import { fmtHouseInfo } from '@/utils/utils'

export default {
    name:  'devicefault',
    data() {
        return {
            form: {
                time: [],
                start_time: '',
                end_time: '',
            },

            // 表格栏
            total: 0,
            list: [],
            pagination: {
                page_num: 1,
                page_sum: 10
            }, 
            columns: [
                {
                    prop: 'terminal_serial',
                    label: '序列号',
                    align: 'center',
                },
                {
                    prop: 'device_model',
                    label: '设备类型',
                    align: 'center',
                },
                {
                    prop: 'fault_type',
                    label: '故障类型',
                    align: 'center',
                },
                {
                    prop: 'housename',
                    label: '位置',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return fmtHouseInfo(row.housename, row.moduleidlist)
                        //  row.housename
                        // return row.moduleidlist
                    }
                },
                {
                    prop: 'recovery',
                    label: '状态',
                    align: 'center',
                    sortable: true,
                    render: (h, params) => {
                        return h('el-tag', {
                            props: {type: params.row.recovery ? 'success' : 'danger' } // 组件的props
                        }, params.row.recovery ? '正常' : '故障')
                    },
                },
                {
                    prop: 'fault_data',
                    label: '故障时间',
                    align: 'center',
                    sortable: true,
                },
                {
                    prop: 'recovered_date',
                    label: '恢复时间',
                    align: 'center',
                    sortable: true,
                },
            ], // 需要展示的列
            operates: {
                width: 250,
                fixed: 'right',
                list: [
                    // {
                    //     label: '操作',
                    //     type: 'primary',
                    //     show: (index, row) => {
                    //         return true
                    //     },
                    //     icon: '',
                    //     plain: true,
                    //     disabled: (index, row) => {
                    //         return false
                    //     },
                    //     method: (index, row) => {
                    //         this.handleAddFollow(index, row)
                    //     }
                    // },
                ]
            }, // 操作按钮组
            options: {
                stripe: true, // 是否为斑马纹 table
                loading: false, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: false // 是否支持列表项选中功能
            }, // table 的参数
        };
    },

    components: { lTable },

    computed: {},

    created() {
        this.getData();
    },

    methods: {
        async getData() {
            let data = Object.assign({}, this.form, this.pagination)
            let res = await Service.getDeviceFault(data);
            if(res) {
                this.list = res.list || [];
                this.total = res.total;
            }
        },
        choseTime(val) {
            if(val) {
                this.form.start_time = val[0]
                this.form.end_time = val[1]
            }else{
                this.form.start_time = ''
                this.form.end_time = ''
            }
        },
        // 查询
        onSubmit() {
            this.getData()
        },
        handleSizeChange (pagination) {
            this.pagination = pagination
            this.getData()
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination
            this.getData()
        },
    }
}

</script>
<style lang='less' scoped>

</style>